export const createNetwork = obj => ({
    name: obj.name,
    investmentFunds: obj.products.map(productId => `/api/investment_funds/${productId}`),
    distributorCompanies: obj.partners.map(p => `/api/distributor_companies/${p.id}`),
    networkAdmins: obj.admins.map(p => `/api/users/${p.id}`),
});

export const updateNetwork = obj => ({
    id: obj.id,
    ...createNetwork(obj),
});
